/**
 * @author Yaochao
 * @date 2021/7/9 12:42
 * @description
 */
import React from 'react';
import {Route} from "react-router-dom";

const Manage = loadable(() => import('./manage/index'));
const TagManage = loadable(() => import('./tagManage/index'));
const BlackList = loadable(() => import('./blacklist/index'));
import loadable from "../loadable";
import PubSub from "pubsub-js";
import noPermissions from "../config/noPermissions/noPermissions";
import Utils from "../public/utils";
import {connect} from "react-redux";

class Customer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>
                {
                    this.props.subInfo.isSub == 0 ?
                        <>
                            <Route path={this.props.match.url + "/manage"} component={Manage}/>
                            <Route exact path={this.props.match.url + "/tag"} component={TagManage}/>
                            <Route path={this.props.match.url + "/blackList"} component={BlackList}/>
                        </> : this.props.subInfo.isSub == 1 ?
                        <>
                            <Route path={this.props.match.url + "/manage"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'customer','customer_manage') ?
                                       Manage : noPermissions}/>
                            <Route exact path={this.props.match.url + "/tag"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'customer','customer_tag') ?
                                       TagManage : noPermissions}/>
                            <Route path={this.props.match.url + "/blackList"}
                                   component={Utils.wxWorkHelperJurisdiction(this.props.subInfo.permissionConf,'customer','customer_blackList') ?
                                       BlackList : noPermissions}/>
                        </> : <></>
                }
            </div>
        )
    }

}

export default connect(state=>{
    const {subReducer} = state
    return {
        subInfo : subReducer
    }
},null)(Customer)